import config from "../config";
import Storage from "./snake.lib.storage";
import Trace from "./snake.lib.trace";
import * as Sentry from "@sentry/browser";
import Url from "./snake.lib.url";

export default class ApiService {
    static getDictionary = async () => {
        const response = await fetch(Url.getSnakeApiUrl() + "/api/co/core/live/dictionary", {
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            method: "GET",
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: null,
                    response: json,
                },
            });

        return json;
    };

    static purchaseInit = async (props) => {
        try {
            const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/init", {
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": this.#customHeaderValue(),
                },
                method: "POST",
                body: JSON.stringify(props),
            });

            if (!response.ok) {
                const json = await response.json();
                throw new Error("HTTP response", { cause: json });
            }

            return await response.json();
        } catch (e) {
            Sentry.captureException(e);
            throw e;
        }
    };

    static cartUpdate = async (props) => {
        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/cart/update", {
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            method: "PUT",
            body: JSON.stringify(props),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: props,
                    response: json,
                },
            });

        return json;
    };

    static paymentInit = async (props) => {
        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/payment", {
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            method: "POST",
            body: JSON.stringify(props),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: props,
                    response: json,
                },
            });

        return json;
    };

    static purchaseAddCoupon = async (props) => {
        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/coupons", {
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            method: "POST",
            body: JSON.stringify(props),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: props,
                    response: json,
                },
            });

        return json;
    };

    static async updateCustomer(firstname, lastname, email, gigyaId, cartId, isAgent) {
        const props = {
            customer: {
                first_name: firstname,
                last_name: lastname,
                email,
                gigya_id: gigyaId,
            },
            cart_id: cartId,
            is_agent: isAgent,
            source: Storage.get("agent_order") || "WEB",
        };

        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/customer", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            body: JSON.stringify(props),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: props,
                    response: json,
                },
            });

        return json;
    }

    static async updateAddresses(email, shippingAddress, billingAddress) {
        const brand = import.meta.env.CO_BRAND;

        /**
         * START - FIX state field for Klarna/US
         */
        let shippingAddressState = shippingAddress.city || "";
        let billingAddressState = billingAddress.city || "";

        if (window.snakeCheckout.currentCountry === "us") {
            Trace.debug("US address state");

            Trace.debug(shippingAddress);
            // Trace.debug(shippingAddress.state || config.countries[window.snakeCheckout.currentCountry].state);
            // Trace.debug(shippingAddress.state ?? config.countries[window.snakeCheckout.currentCountry].state);

            Trace.debug(billingAddress);
            // Trace.debug(billingAddress.state || config.countries[window.snakeCheckout.currentCountry].state);
            // Trace.debug(billingAddress.state ?? config.countries[window.snakeCheckout.currentCountry].state);

            shippingAddressState = shippingAddress.state || config.countries[window.snakeCheckout.currentCountry].state;
            billingAddressState = billingAddress.state || shippingAddress.state || config.countries[window.snakeCheckout.currentCountry].state;
        }
        /**
         * END - FIX state field for Klarna/US
         */

        const props = {
            cart_id: window.snakeCheckout.initData.cart_id,
            addresses: {
                shipping: {
                    first_name: shippingAddress.firstName,
                    last_name: shippingAddress.lastName,
                    email,
                    company: brand,
                    address1: (shippingAddress.addressLine1 || "").trim() + " " + (shippingAddress.normStreetNum || ""),
                    address2: shippingAddress.addressLine2,
                    city: shippingAddress.city,
                    state_or_province: shippingAddressState,
                    state_or_province_code: shippingAddressState,
                    country_code: config.countries[window.snakeCheckout.currentCountry].countryCode,
                    postal_code: shippingAddress.postalCode,
                    phone: shippingAddress.phoneNumber,
                },
                billing: {
                    first_name: billingAddress.firstName,
                    last_name: billingAddress.lastName,
                    email,
                    company: brand,
                    address1: (billingAddress.addressLine1 || "").trim() + " " + (billingAddress.normStreetNum || ""),
                    address2: billingAddress.addressLine2,
                    city: billingAddress.city,
                    state_or_province: billingAddressState,
                    state_or_province_code: billingAddressState,
                    country_code: config.countries[window.snakeCheckout.currentCountry].countryCode,
                    postal_code: billingAddress.postalCode,
                    phone: billingAddress.phoneNumber,
                },
            },
        };

        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/addresses", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            body: JSON.stringify(props),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: props,
                    response: json,
                },
            });

        return json;
    }

    static completeOrder = async (orderId, paymentMethod, invoice) => {
        const props = {
            order_id: window.snakeCheckout.orderId || orderId,
            payment_method: paymentMethod,
            invoice: invoice || false,
        };

        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/complete", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            body: JSON.stringify(props),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: props,
                    response: json,
                },
            });

        return json;
    };

    static orderDetails = (vars) => {
        // TODO: use V4
        return new Promise((resolve, reject) => {
            fetch(Url.getSnakeApiUrl() + "/api/v3/core/checkout/orders/get", {
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": this.#customHeaderValue(),
                },
                method: "POST",
                body: JSON.stringify(vars),
            })
                .then((response) => response.json())
                .then((data) => resolve(data))
                .catch((e) => reject(e));
        });
    };

    static paymentVerify = async (redirectResult, orderId) => {
        const props = {
            redirect_result: redirectResult,
            order_id: orderId,
        };

        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/payment/verify", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            body: JSON.stringify(props),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: props,
                    response: json,
                },
            });

        return json;
    };

    static #customHeaderValue = () => {
        return btoa(encodeURIComponent(`{"uri":${window.location.href}}`));
    };

    static getSummaryItems = async (cartId) => {
        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/services/summary/items/" + cartId + "?action=build", {
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            method: "GET",
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: null,
                    response: json,
                },
            });

        return json;
    };

    static getItemsStock = async (props) => {
        const response = await fetch(Url.getSnakeApiUrl() + "/api/v2/core/live/ecommerce-availability", {
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            method: "POST",
            body: JSON.stringify(props),
        });

        const json = await response.json();

        if (!response.ok || json.error)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: props,
                    response: json,
                },
            });

        return json;
    };

    static sendPayLink = async (cartId) => {
        const response = await fetch(Url.getSnakeApiUrl() + "/api/v4/core/checkout/purchase/payment/link", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            body: JSON.stringify({
                cart_id: cartId,
            }),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: cartId,
                    response: json,
                },
            });

        return json;
    };

    static getKlarna = async (productCode) => {
        const response = await fetch(Url.getSnakeApiUrl() + "/api/v2/core/live/payments/klarna/web-messages", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
            body: JSON.stringify({
                productCode,
            }),
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: productCode,
                    response: json,
                },
            });

        return json;
    };

    static getFullKitUpselling = async (sku) => {
        const response = await fetch(`${Url.getSnakeApiUrl()}/api/v2/core/live/upselling/fullkit?sku=${sku}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": this.#customHeaderValue(),
            },
        });

        const json = await response.json();

        if (!response.ok)
            throw Error("", {
                cause: {
                    endpoint: response?.url ?? "",
                    request: sku,
                    response: json,
                },
            });

        return json;
    };
}
